import React from "react";
import { Modal, ModalBody, FormGroup, Input, Row, Col, Label, FormFeedback } from "reactstrap";
import { Form, Formik } from "formik";
import { LabelText } from "../Utils/Input";
import SelectField from "../Utils/SelectField";
import CommonButton from "../Utils/CommonButton";
import CommonDateTimePicker from "../Utils/CommonDateTimePicker";
import { validationSchemaForAdjustment, validationSchemaForRecharge } from "./constants/validationSchema";

const CustomerAdjustmentModal = ({
    modalOpen,
    toggleModal,
    modalType,
    initialRechargeValues,
    initialCurrencyAdjustValues,
    initialAdjustValues,
    handleBalanceConfirm,
    handleConfirm,
    currencyRechargeArray,
    currencyAdjustArray,
    nonCurrencyAdjustArray,
    idArray,
    subscriptionIdArray,
    offerCodeArray,
    chargedResource,
    setModalOpen
}) => {
    const dateTimeFormat = `${localStorage.getItem("dateFormat") || "DD MMM YYYY"}  hh:mm:ss A`;
    return (
        <Modal isOpen={modalOpen} toggle={toggleModal} centered={true} size="md" className="custom-modal">
            <h5 className="text-center w-100 mt-0 fw-semibold py-3 ">
                {modalType === "Recharge" ? "Recharge" : modalType === "Adjust" ? "Currency Adjustment" : "Non-Currency Adjustment"}
            </h5>
            <ModalBody>
                {modalType === "Recharge" ? (
                    <Formik
                        initialValues={initialRechargeValues}
                        validationSchema={validationSchemaForRecharge}
                        onSubmit={handleBalanceConfirm}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            setFieldValue,
                            handleSubmit
                        }) => (
                            <>
                                <Form onSubmit={handleSubmit}>
                                    <FormGroup className="mt-n3">
                                        <LabelText displayText="Resource" important={"*"} className={"text-danger"} />
                                        {(touched.resourceName && errors.resourceName) && (
                                            <p className="text-danger validation-font-size mb-1">
                                                {errors.resourceName}
                                            </p>
                                        )}
                                        <SelectField
                                            name="resourceName"
                                            placeholder="Select Resource..."
                                            className={
                                                touched.resourceName && errors.resourceName ? 'error-input' : ''
                                            }
                                            value={
                                                values.resourceName ? currencyRechargeArray.find(option => option.value === values.resourceName) : null
                                            }
                                            handleChange={(selectedOption) => {
                                                setFieldValue("resourceName", selectedOption?.value || "");
                                            }}
                                            options={currencyRechargeArray}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <LabelText displayText="Recharge Amount" important={"*"} className={"text-danger"} />
                                        {(touched.adjustmentAmount && errors.adjustmentAmount) && (
                                            <p className="text-danger validation-font-size mb-1">
                                                {errors.adjustmentAmount}
                                            </p>
                                        )}
                                        <Input
                                            type="number"
                                            value={values.adjustmentAmount}
                                            onChange={(e) => setFieldValue("adjustmentAmount", e.target.value)}
                                            placeholder="Enter the Recharge Amount"
                                            className={touched.adjustmentAmount && errors.adjustmentAmount ? 'is-invalid' : ''}
                                        />
                                    </FormGroup>
                                    <div className="d-flex justify-content-center gap-2 mt-2">
                                        <CommonButton
                                            outline={true}
                                            className={
                                                "btn-label rv-secondary-btn rounded-1 px-1 ps-3 py-1  w-md-auto text-nowrap"
                                            }
                                            color={"main-color"}
                                            type={"button"}
                                            buttonAction={() => {
                                                setModalOpen(false);
                                            }}
                                            buttonText={"Close"}
                                            icon={
                                                <i className="ri-close-fill label-icon align-middle fs-16 me-1" style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}>

                                                </i>}
                                            btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                        />
                                        <CommonButton
                                            color={"secondary"}
                                            type="submit"
                                            buttonText={"Submit"}
                                            icon={<i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>}
                                            className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1  w-md-auto text-nowrap"
                                            btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                        />
                                    </div>
                                </Form>
                            </>
                        )}
                    </Formik>
                ) : modalType === "Adjust" ? (
                    <>
                        <Formik
                            initialValues={initialCurrencyAdjustValues}
                            validationSchema={validationSchemaForRecharge}
                            onSubmit={handleBalanceConfirm}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                setFieldValue,
                                handleSubmit
                            }) => (
                                <>
                                    <Form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col lg={12} sm={12} md={12} xs={12} className="mt-n3">
                                                <FormGroup>
                                                    <LabelText displayText="Description" />
                                                    {(touched.description && errors.description) && (
                                                        <p className="text-danger validation-font-size mb-1">
                                                            {errors.description}
                                                        </p>
                                                    )}
                                                    <Input
                                                        type="text"
                                                        value={values?.description}
                                                        onChange={(e) => setFieldValue("description", e.target.value)}
                                                        placeholder="Enter description"
                                                        className={touched.description && errors.description ? 'is-invalid' : ''}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col lg={6} sm={6} md={6} xs={6}>
                                                <FormGroup>
                                                    <LabelText displayText="Adjustment Amount" />
                                                    {(touched.adjustmentAmount && errors.adjustmentAmount) && (
                                                        <p className="text-danger validation-font-size mb-1">
                                                            {errors.adjustmentAmount}
                                                        </p>
                                                    )}
                                                    <div className="input-group">
                                                        <span className="input-group-text">{chargedResource[0]?.currencySymbol}</span>
                                                        <Input
                                                            type="number"
                                                            value={values?.adjustmentAmount}
                                                            onChange={(e) => setFieldValue("adjustmentAmount", e.target.value)}
                                                            placeholder="Enter adjustment amount"
                                                            className={touched.adjustmentAmount && errors.adjustmentAmount ? 'is-invalid' : ''}
                                                        />
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            <Col lg={6} sm={6} md={6} xs={6}>
                                                <FormGroup>
                                                    <LabelText displayText="Resource" important={"*"} className={"text-danger"} />
                                                    {(touched.resourceName && errors.resourceName) && (
                                                        <p className="text-danger validation-font-size mb-1">
                                                            {errors.resourceName}
                                                        </p>
                                                    )}
                                                    <SelectField
                                                        name="resourceName"
                                                        className={
                                                            touched.resourceName && errors.resourceName ? 'error-input' : ''
                                                        }
                                                        value={
                                                            values.resourceName
                                                                ? currencyAdjustArray.find(option => option.value === values.resourceName)
                                                                : null
                                                        }
                                                        handleChange={(selectedOption) => {
                                                            setFieldValue("resourceName", selectedOption?.value || "");
                                                        }}
                                                        options={currencyAdjustArray}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <div className="d-flex justify-content-center gap-2 mt-2">
                                                <CommonButton
                                                    outline={true}
                                                    className={
                                                        "btn-label rv-secondary-btn rounded-1 px-1 ps-3 py-1  w-md-auto text-nowrap"
                                                    }
                                                    color={"main-color"}
                                                    type={"button"} buttonAction={() => {
                                                        setModalOpen(false);
                                                    }}
                                                    buttonText={"Close"}
                                                    icon={
                                                        <i className="ri-close-fill label-icon align-middle fs-16 me-1" style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}>

                                                        </i>}
                                                    btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                                />
                                                <CommonButton
                                                    color={"secondary"}
                                                    type="submit"
                                                    buttonText={"Submit"}
                                                    icon={<i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>}
                                                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1  w-md-auto text-nowrap"
                                                    btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                                />
                                            </div>
                                        </Row>
                                    </Form>
                                </>
                            )}
                        </Formik>
                    </>
                ) : (
                    <Formik
                        initialValues={initialAdjustValues}
                        validationSchema={validationSchemaForAdjustment}
                        onSubmit={handleConfirm}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            touched,
                            setFieldValue,
                            handleBlur
                        }) => (
                            <Form>
                                <Row>
                                    <Col md={12} className="mt-n3">
                                        <FormGroup>
                                            <LabelText displayText="Description" />
                                            {(touched.description && errors.description) && (
                                                <p className="text-danger validation-font-size mb-1">
                                                    {errors.description}
                                                </p>
                                            )}
                                            <Input
                                                type="text"
                                                name="description"
                                                value={values.description}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="Enter description"
                                                className={touched.description && errors.description ? 'is-invalid' : ''}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <LabelText displayText="Adjustment Amount" important={"*"} className={"text-danger"} />
                                            {(touched.adjustmentAmount && errors.adjustmentAmount) && (
                                                <p className="text-danger validation-font-size mb-1">
                                                    {errors.adjustmentAmount}
                                                </p>
                                            )}
                                            <Input
                                                type="number"
                                                name="adjustmentAmount"
                                                value={values.adjustmentAmount}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="Enter adjustment amount"
                                                className={touched.adjustmentAmount && errors.adjustmentAmount ? 'is-invalid' : ''}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <LabelText displayText="Resource" important={"*"} className={"text-danger"} />
                                            {(touched.resourceName && errors.resourceName) && (
                                                <p className="text-danger validation-font-size mb-1">
                                                    {errors.resourceName}
                                                </p>
                                            )}
                                            <SelectField
                                                name="resourceName"
                                                className={
                                                    touched.resourceName && errors.resourceName ? 'error-input' : ''
                                                }
                                                value={
                                                    values.resourceName
                                                        ? nonCurrencyAdjustArray.find(option => option.value === values.resourceName)
                                                        : null
                                                }
                                                handleChange={(selectedOption) => {
                                                    setFieldValue("resourceName", selectedOption?.value || "");
                                                }}
                                                options={nonCurrencyAdjustArray}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Balance Item Spec ID</Label>
                                            {(touched.balanceItemSpecId && errors.balanceItemSpecId) && (
                                                <p className="text-danger validation-font-size mb-1">
                                                    {errors.balanceItemSpecId}
                                                </p>
                                            )}
                                            <SelectField
                                                name="balanceItemSpecId"
                                                className={
                                                    touched.balanceItemSpecId && errors.balanceItemSpecId ? 'error-input' : ''
                                                }
                                                value={
                                                    values.balanceItemSpecId
                                                        ? idArray.find(option => option.value === values.balanceItemSpecId)
                                                        : null
                                                }
                                                handleChange={(selectedOption) => {
                                                    setFieldValue("balanceItemSpecId", selectedOption?.value || "");
                                                }}
                                                options={idArray}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Subscription Id</Label>
                                            {(touched.subscriptionId && errors.subscriptionId) && (
                                                <p className="text-danger validation-font-size mb-1">
                                                    {errors.subscriptionId}
                                                </p>
                                            )}
                                            <SelectField
                                                name="subscriptionId"
                                                className={
                                                    touched.subscriptionId && errors.subscriptionId ? 'error-input' : ''
                                                }
                                                value={
                                                    values.subscriptionId
                                                        ? subscriptionIdArray.find(option => option.value === values.subscriptionId)
                                                        : null
                                                }
                                                handleChange={(selectedOption) => {
                                                    setFieldValue("subscriptionId", selectedOption?.value || "");
                                                }}
                                                options={subscriptionIdArray}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Offer Code</Label>
                                            {(touched.offerCode && errors.offerCode) && (
                                                <p className="text-danger validation-font-size mb-1">
                                                    {errors.offerCode}
                                                </p>
                                            )}
                                            <SelectField
                                                name="offerCode"
                                                className={
                                                    touched.offerCode && errors.offerCode ? 'error-input' : ''
                                                }
                                                value={
                                                    values.offerCode
                                                        ? offerCodeArray.find(option => option.value === values.offerCode)
                                                        : null
                                                }
                                                handleChange={(selectedOption) => {
                                                    setFieldValue("offerCode", selectedOption?.value || "");
                                                }}
                                                options={offerCodeArray}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}></Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <LabelText displayText="Valid From" />
                                            <CommonDateTimePicker
                                                views={["year", "month", "day", "hours", "minutes", "seconds"]}
                                                className={`form-control`}
                                                value={values.validFrom}
                                                name="validFrom"
                                                format={dateTimeFormat}
                                                handleChange={(value) => setFieldValue("validFrom", value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <LabelText displayText="Valid To" />
                                            <CommonDateTimePicker
                                                views={["year", "month", "day", "hours", "minutes", "seconds"]}
                                                className={`form-control`}
                                                value={values.validTo}
                                                name="validTo"
                                                format={dateTimeFormat}
                                                handleChange={(value) => setFieldValue("validTo", value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="d-flex justify-content-center gap-2 mt-2">
                                    <CommonButton
                                        outline={true}
                                        className={
                                            "btn-label rv-secondary-btn rounded-1 px-1 ps-3 py-1  w-md-auto text-nowrap"
                                        }
                                        color={"main-color"}
                                        type={"button"}
                                        buttonAction={() => {
                                            setModalOpen(false);
                                        }}
                                        buttonText={"Close"}
                                        icon={
                                            <i className="ri-close-fill label-icon align-middle fs-16 me-1" style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}>

                                            </i>}
                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                    />
                                    <CommonButton
                                        color={"secondary"}
                                        type="submit"
                                        buttonText={"Submit"}
                                        icon={<i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>}
                                        className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1  w-md-auto text-nowrap"
                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                    />
                                </div>
                            </Form>
                        )}
                    </Formik>
                )}
            </ModalBody>
        </Modal>
    );
};

export default CustomerAdjustmentModal;